import { Component } from '@angular/core';
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';

/**
 * Component for handling empty view states.
 */
@Component({
	selector: 'empty-view',
	templateUrl: './empty-view.component.html',
	styleUrl: './empty-view.component.css'
})
export class EmptyViewComponent implements OnInit, OnDestroy {
	@Input() viewType: string = '';

	private userEventSubscription!: Subscription;

	LOCALIZATION: any;

	constructor(
		private userService: UserService
	) {
		console.log("Init EmptyViewComponent");
	}

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if (event === 'localizationLoaded') {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});
	}

	ngOnDestroy() {
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}
	}
}
